// extracted by mini-css-extract-plugin
export default {"templateOne":"table-module__templateOne__GDW6A","templateTwo":"table-module__templateTwo__J0Fkf"};